import { MySwal } from '../library/swal';

export const CPANEL_FEED_REFRESH_EVENT = 'cpanel:refresh-feeds';

let refreshDebounceTimer = null;

export const dispatchCpanelFeedRefresh = () => {
  if (refreshDebounceTimer) {
    window.clearTimeout(refreshDebounceTimer);
  }
  refreshDebounceTimer = window.setTimeout(() => {
    refreshDebounceTimer = null;
    window.dispatchEvent(new CustomEvent(CPANEL_FEED_REFRESH_EVENT));
  }, 400);
};

export const isJobQueuedResponse = (response) =>
  response?.status === 202 && Boolean(response?.data?.jobId);

export const showJobQueuedFeedback = async ({ jobId, actionLabel }) => {
  await MySwal.fire({
    icon: 'info',
    title: 'Diproses di background',
    html: `<strong>${actionLabel}</strong> sedang berjalan di Job Runner.<br/><br/>
      Anda akan mendapat <strong>notifikasi</strong> saat selesai atau gagal (dengan detail error).<br/><br/>
      <a href="/cpanel/jobs/${jobId}" class="fw-bold">Lihat progress job</a>`,
    confirmButtonText: 'Mengerti',
  });
};

export const handleJobQueuedSuccess = async ({ response, actionLabel, close, fetch }) => {
  if (!isJobQueuedResponse(response)) {
    return false;
  }

  MySwal.close();
  close?.();
  fetch?.();
  dispatchCpanelFeedRefresh();
  await showJobQueuedFeedback({
    jobId: response.data.jobId,
    actionLabel,
  });
  return true;
};

export const handleJobRequestError = (err, fallbackMessage) => {
  const message =
    err?.response?.data?.message || err?.message || fallbackMessage || 'Permintaan gagal.';
  MySwal.fire({
    icon: 'error',
    title: 'Gagal',
    text: message,
  });
};
